import { render } from "./Tab3.vue?vue&type=template&id=37e306a3&scoped=true&ts=true"
import script from "./Tab3.vue?vue&type=script&lang=ts"
export * from "./Tab3.vue?vue&type=script&lang=ts"

import "./Tab3.vue?vue&type=style&index=0&id=37e306a3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e306a3"]])

export default __exports__